import { Form, Formik } from 'formik';
import { FC } from 'react';

import { CheckoutDescription } from '@/checkout/components/CheckoutDescription/CheckoutDescription';
import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import { InputCheckboxFormik } from '@/general/components/forms/Input/InputCheckboxFormik';
import { Checkbox } from '@/general/components/forms/Input/atoms/OptionFieldInput';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';
import {
  PersonalizedQuoteFormProps,
  TermsAndConditionsFormValidation,
  TermsAndConditionsFormValues,
  isCheckTermsAndConditionsOptions,
} from './PersonalizedQuoteForm.type';

const initialValues: TermsAndConditionsFormValues = {
  isCheckTermsAndConditions: '',
  isBusinessUseSelected: false,
};

export const TermsAndConditionsForm: FC<PersonalizedQuoteFormProps<TermsAndConditionsFormValues>> = ({
  onSubmit,
  values,
  onBack,
  isLoggedIn,
}) => {
  const termsAndConditionsPersonal = getMicrocopy(MICROCOPY.CHECKOUT_FINANCE_QUOTE_INFO_FORM_TERM_CONDITIONS, true);
  const termsAndConditionsBusiness = getMicrocopy(
    MICROCOPY.CHECKOUT_FINANCE_QUOTE_INFO_FORM_TERM_CONDITIONS_FOR_BUSINESS,
    true,
  );

  const termsAndConditionsOptions = isCheckTermsAndConditionsOptions.map((item) => ({
    value: item.value,
    label: getMicrocopy(item.label),
  }));
  const ctaCopy = getMicrocopy(
    isLoggedIn
      ? MICROCOPY.PERSONALIZED_QUOTE_TERMS_AND_CONDITIONS_CTA
      : MICROCOPY.PERSONALIZED_QUOTE_TERMS_AND_CONDITIONS_CTA_NEW_USER,
  );
  const termsAndConditionsCtaDescription = getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_TERMS_AND_CONDITIONS_DESCRIPTION);

  return (
    <section className={styles.termsAndConditionsWrapper}>
      <CheckoutDescription
        title={getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_TERMS_AND_CONDITIONS_HEADER)}
        onBack={onBack}
      />
      <div className={styles.titleContent}>
        Before we provide your personalised quote please read the below carefully:
      </div>
      {values.isBusinessUseSelected ? (
        <div className={styles.content}>{termsAndConditionsBusiness}</div>
      ) : (
        <div className={styles.content}>{termsAndConditionsPersonal}</div>
      )}
      <div className={styles.loanDetails}>
        <Formik
          initialValues={{ ...initialValues, ...values }}
          onSubmit={onSubmit}
          validationSchema={TermsAndConditionsFormValidation}
        >
          {(props) => (
            <div className={styles.termsAndConditions}>
              <Form className={styles.form}>
                <div className={styles.checkbox}>
                  <InputCheckboxFormik
                    id="termsAndConditions"
                    name="isCheckTermsAndConditions"
                    data-testid="terms-and-conditions"
                    options={termsAndConditionsOptions}
                    disabled={props.isSubmitting}
                    variant="isolated"
                    inputIcon={Checkbox}
                  />
                </div>

                <footer className={styles.footer}>
                  <Button type="submit" isLoading={props.isSubmitting} fullWidth data-testid="submit">
                    {ctaCopy}
                  </Button>
                  <div className={styles.description}>{termsAndConditionsCtaDescription}</div>
                </footer>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </section>
  );
};
